import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // Global request timeout — without this, a hanging server keeps promises
  // pending forever, which broke Admin → URL Import (Categories stuck on
  // "Loading…") on production. 20s is generous for slow supplier scrapes
  // but forces UI to unblock instead of waiting forever.
  timeout: 20000,
});

export default api;
